export default "__VITE_ASSET__Bp5mqt8v__"